import { render, staticRenderFns } from "./NonConformities.vue?vue&type=template&id=c4a9aec8&"
import script from "./NonConformities.vue?vue&type=script&lang=js&"
export * from "./NonConformities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports